import { useSelector } from "react-redux";

const useDealer = () => {
  const dealer = useSelector(state => state.dealer.dealer);
  return dealer;
};

export default useDealer; 